<template>
  <div class="lossOverflowReport">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList || []"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width || 120"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'decreaseOverflowStatus'">
              {{ requestStatusData[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.field === 'decreaseOverflowType'">
              {{ decreaseOverflowTypeData[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!--批量确认 -->
    <BatchConfirmDialog ref="batchConfirmDialog" />
  </div>
</template>

<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import API from '@/api/wareHouse/lossOverflowReport.js';
  import DataBaseAPI from '@/api/dataBase';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import BatchConfirmDialog from '@/components/Dialog/batchConfirmDialog';
  // import status from '@/common/js/status';
  // ============ sunxueping  ============
  import tableMixins from '@/common/mixins/table.js';
  // ================================================
  export default {
    components: {
      SiruiTable,
      SiruiSearch,
      BatchConfirmDialog,
    },
    name: 'lossOverflowReportList',
    mixins: [tableMixins],
    data() {
      return {
        load: false,
        img: '/static/img/tips.png',
        query: {
          decreaseOverflowNo: null,
          decreaseOverflowCreateDateStart: null,
          decreaseOverflowCreateDateEnd: null,
          storage: null,
          decreaseOverflowDepartmentNo: null,
          decreaseOverflowType: null,
          product: null,
          batchNo: null,
          decreaseOverflowBusinessPerson: null,
          purchaseNo: null,
          decreaseOverflowStatus: null,
          partner: null,
          voucherNo: null,
        },
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        decreaseOverflowTypeData: ['报损', '报溢'], //申请状态下拉列表
        rowData: {}, //被选中的列
        requestStatusData: ['已保存', '审批中', '已驳回', '已执行', '已审核通过', '已冲销'],
        companyList: [],
        decreaseOverflowStatusList: [
          { value: 0, label: '已保存' },
          { value: 1, label: '审批中' },
          { value: 2, label: '已驳回' },
          { value: 3, label: '已执行' },
          { value: 4, label: '已审核通过' },
          { value: 5, label: '已冲销' },
        ],
        columnList: [],
        //表格显示字段
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'decreaseOverflowNo',
            title: 'lossOverflowReport.search.decreaseOverflowNo',
            visible: true,
          },
          {
            field: 'decreaseOverflowType',
            title: 'lossOverflowReport.search.decreaseOverflowType',
            visible: true,
          },
          {
            field: 'decreaseOverflowStatus',
            title: 'lossOverflowReport.search.decreaseOverflowStatus',
            visible: true,
          },
          {
            field: 'accountingStatus',
            title: 'lossOverflowReport.search.accountingStatus',
            visible: true,
            dictType: 'post_status',
          },
          {
            field: 'decreaseOverflowCreateDate',
            title: 'lossOverflowReport.search.decreaseOverflowCreateDate',
            visible: true,
          },
          { field: 'storageName', title: 'lossOverflowReport.search.storageNo', visible: true },
          // { field: "salesmanName", title: "lossOverflowReport.search.salesmanNo",  visible: true },
          { field: 'productName', title: 'lossOverflowReport.search.product', visible: true },
          { field: 'partnerName', title: 'lossOverflowReport.search.partner', visible: true },
          {
            field: 'decreaseOverflowDepartmentName',
            title: 'lossOverflowReport.search.decreaseOverflowDepartmentNo',
            visible: true,
          },
          {
            field: 'decreaseOverflowBusinessPersonName',
            title: 'lossOverflowReport.search.decreaseOverflowBusinessPerson',
            visible: true,
          },
          {
            field: 'decreaseOverflowQuantity',
            title: 'lossOverflowReport.search.decreaseOverflowQuantity',
            visible: true,
          },
          {
            field: 'decreaseOverflowPackage',
            title: 'lossOverflowReport.search.decreaseOverflowPackage',
            visible: true,
          },
          {
            field: 'decreaseOverflowUnitName',
            title: 'lossOverflowReport.search.decreaseOverflowUnit',
            visible: true,
          },
          {
            field: 'decreaseOverflowUnitPrice',
            title: 'lossOverflowReport.search.decreaseOverflowUnitPrice',
            visible: true,
          },
          {
            field: 'businessDecreaseOverflowAmount',
            title: 'lossOverflowReport.search.businessDecreaseOverflowAmount',
            visible: true,
          },
          { field: 'purchaseNo', title: 'lossOverflowReport.search.purchaseNo', visible: true },
          { field: 'purchaseNo', title: 'lossOverflowReport.search.purchaseNo', visible: true },
          { field: 'voucherNo', title: 'lossOverflowReport.search.voucherNo', visible: true },
          {
            field: 'decreaseOverflowCreatePersonName',
            title: 'lossOverflowReport.search.decreaseOverflowCreatePerson',
            visible: true,
          },
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'decreaseOverflowNo',
            name: this.$t('lossOverflowReport.search.decreaseOverflowNo'),
            type: 'input',
            placeholder: this.$t('lossOverflowReport.search.decreaseOverflowNoPlaceholder'),
          },
          {
            prop: 'decreaseOverflowCreateDateStart',
            name: this.$t('lossOverflowReport.search.decreaseOverflowCreateDateStart'),
            type: 'startDaterangePicker',
            placeholder: this.$t(
              'lossOverflowReport.search.decreaseOverflowCreateDateStartPlaceholder'
            ),
          },
          {
            prop: 'decreaseOverflowCreateDateEnd',
            name: this.$t('lossOverflowReport.search.decreaseOverflowCreateDateEnd'),
            type: 'endDaterangePicker',
            placeholder: this.$t(
              'lossOverflowReport.search.decreaseOverflowCreateDateEndPlaceholder'
            ),
          },
          {
            type: 'searchTableSpec',
            prop: 'storage',
            isMultiple: true,
            name: this.$t('lossOverflowReport.search.storageNo'),
            searchType: 'warehouse',
          },
          // {
          //   type: 'searchTableSpec',
          //   prop: 'salesmanNo',
          //   name: this.$t("lossOverflowReport.search.salesmanNo"),
          //   searchType: 'personnel'
          // },
          {
            prop: 'decreaseOverflowDepartmentNo',
            name: this.$t('lossOverflowReport.search.decreaseOverflowDepartmentNo'),
            placeholder: this.$t(
              'lossOverflowReport.search.decreaseOverflowDepartmentNoPlaceholder'
            ),
            type: 'treeSelect',
            apiUrl: DataBaseAPI.LIST_COMPANY_API,
            apiData: {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            clearable: false,
          },
          {
            prop: 'decreaseOverflowType',
            name: this.$t('lossOverflowReport.search.decreaseOverflowType'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('lossOverflowReport.search.decreaseOverflowTypePlaceholder'),
            options: [
              { label: '报损', value: '0' },
              { label: '报溢', value: '1' },
            ],
          },
          {
            type: 'searchTableSpec',
            prop: 'product',
            isMultiple: true,
            name: this.$t('lossOverflowReport.search.product'),
            searchType: 'goodsDetail',
          },
          {
            prop: 'batchNo',
            name: this.$t('lossOverflowReport.search.batchNo'),
            type: 'input',
            placeholder: this.$t('lossOverflowReport.search.batchNoPlaceholder'),
          },
          {
            type: 'searchTableSpec',
            prop: 'decreaseOverflowBusinessPerson',
            isMultiple: true,
            name: this.$t('lossOverflowReport.search.decreaseOverflowBusinessPerson'),
            searchType: 'personnel',
          },
          {
            prop: 'purchaseNo',
            name: this.$t('lossOverflowReport.search.purchaseNo'),
            type: 'input',
            placeholder: this.$t('lossOverflowReport.search.purchaseNoPlaceholder'),
          },
          {
            prop: 'decreaseOverflowStatus',
            name: this.$t('lossOverflowReport.search.decreaseOverflowStatus'),
            type: 'select',
            clearabled: true,
            placeholder: this.$t('lossOverflowReport.search.decreaseOverflowStatusPlaceholder'),
            options: this.decreaseOverflowStatusList,
          },
          {
            type: 'searchTableSpec',
            prop: 'partner',
            isMultiple: true,
            name: this.$t('lossOverflowReport.search.partner'),
            searchType: 'supplier',
            extraData: {
              departmentCode: this.query.decreaseOverflowDepartmentNo,
              // companyCode:this.userInfo.userInfo.companyCode
            },
          },
          {
            // 入账状态
            type: 'dict',
            prop: 'accountingStatus',
            name: this.$t('paymentList.table.accountingStatus'),
            dictType: 'post_status',
          },
          {
            prop: 'voucherNo',
            name: '凭证号',
            type: 'input',
            placeholder: this.$t('请输入凭证号'),
          },
        ];
      },
    },
    /**页面必要代码Start */
    mounted() {
      this.getData();
      this.getButtonList();
    },
    methods: {
      //获取数据
      getData() {
        this.load = true;
        let query = JSON.parse(JSON.stringify(this.query));
        //const query = this.$refs.siruiSearch.query;
        query.storageNo =
          query.storage && query.storage.length > 0 ? query.storage[0].storageCode : null;
        // query.productName = query.product && query.product.length>0 ?query.product[0].productDetailCode:null
        query.decreaseOverflowBusinessPersonName =
          query.decreaseOverflowBusinessPerson && query.decreaseOverflowBusinessPerson.length > 0
            ? query.decreaseOverflowBusinessPerson[0].id
            : null;
        // query.partnerNo = query.partner && query.partner.length>0 ?query.partner[0].partnerCode:null
        (query.partnerNo =
          query.partner && query.partner[0]
            ? query.partner[0].allPartnerCode
              ? query.partner[0].allPartnerCode
              : query.partner[0].partnerCode
            : ''),
          (query.productNo =
            query.product && query.product[0]
              ? query.product[0].allProductDetailCode
                ? query.product[0].allProductDetailCode
                : query.product[0].productDetailCode
              : ''),
          delete query.storage;
        delete query.product;
        delete query.decreaseOverflowBusinessPerson;
        delete query.partner;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        this.$axios.post(API.GET_LIST_API, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.info(column, property, order);
      },
      //点击按钮触发的方法
      chooseClick(type) {
        //新增
        if (type === 'add') {
          this.add();
        } else if (type === 'doBatchConfirm') {
          this.doBatchConfirm(
            'AE_INV_STOCK_TAKING',
            { idList: this.multipleSelection.map((it) => it.id) },
            'idList'
          );
        }
        // ============ sunxueping 添加批量过账 ============
        else if (type == 'syncVoucher') {
          this.syncVoucher();
        }
        // 批量标记过账
        else if (type == 'signSyncVoucher') {
          this.signSyncVoucher();
        }
      },
      // ============ sunxueping 添加批量过账 ============
      syncVoucher() {
        const params = {};
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        params.idList = [];
        if (selectedList.length > 0) {
          selectedList.map((item) => {
            params.idList.push(item.id);
          });
        }
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            params.idList.push(item.id);
          });
        }
        if (!params.idList.length) {
          this.$alert('请选择请选择单据');
          return false;
        }
        this.batchSyncVoucher(API.BATCH_SYN_VOUCHER, params);
      },
      // 批量标记过账
      signSyncVoucher() {
        const params = {};
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        params.idList = [];
        if (selectedList.length > 0) {
          selectedList.map((item) => {
            params.idList.push(item.id);
          });
        }
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            params.idList.push(item.id);
          });
        }
        if (!params.idList.length) {
          this.$alert('请选择请选择单据');
          return false;
        }
        this.batchSyncVoucher(API.BATCH_SYN_SIGN_VOUCHER, params);
      },
      //新增
      add() {
        let path = {
          path: '/wareHouse/lossOverflowReportAdd',
          name: 'lossOverflowReportAdd',
          meta: {
            keepAlive: true,
          },
          query: {},
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //双击事件
      dblclickEvent(value) {
        let path = {
          path: '/wareHouse/lossOverflowReportDetail',
          name: 'lossOverflowReportDetail',
          meta: {
            keepAlive: false,
          },
          query: { decreaseOverflowNo: value.row.decreaseOverflowNo, isEdit: true },
        };
        if (value.row.decreaseOverflowStatus == '0' || value.row.decreaseOverflowStatus == '2') {
          path.path = '/wareHouse/lossOverflowReportEdit';
          (path.name = 'lossOverflowReportEdit'),
            (path.query = { decreaseOverflowNo: value.row.decreaseOverflowNo, isEdit: false });
        }
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      /**页面必要代码End */
    },
  };
</script>
